// extracted by mini-css-extract-plugin
export default {"container":"IgnoreResponsiveContainerPadding_container__jwJiL"};